import { service } from "@ember/service";
import { Ability } from "ember-can";
import type SemeiaSessionService from "parog-web/services/session";

export default class TlsConsentStatusDropdownAbility extends Ability {
  @service declare session: SemeiaSessionService;

  get canRead(): boolean | undefined {
    return (
      this.session.medic &&
      (this.session.medic.isSuperUser ||
        this.session.medic.therapeuticalAreaIds.some(
          therapeuticalArea => therapeuticalArea == "nephro"
        ))
    );
  }
}
